import { render, staticRenderFns } from "./a-lottie.vue?vue&type=template&id=06ce79d3&scoped=true"
import script from "./a-lottie.vue?vue&type=script&lang=js"
export * from "./a-lottie.vue?vue&type=script&lang=js"
import style0 from "./a-lottie.vue?vue&type=style&index=0&id=06ce79d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce79d3",
  null
  
)

export default component.exports